import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { RightSideTrailType, RightSideTrailInitialStateType } from "../../../models/right-side-trail-model";
import ProductRightSideRelatedEventsService from '../../../services/right-side/product-right-side-related-events.service';

const initialState: RightSideTrailInitialStateType = {
    rightSideFeaturedBooksData: [],
    rightSideFeaturedLearningData: [],
    rightSideTrendingNewsData: [],
    rightSidePopularEventsData: [],
    Loading: true,
    Error: undefined,
};

export const retrieveProductRightSideRelatedEvents = createAsyncThunk('ProductRightSideRelatedEvents/retrieve',
    async (productPath: string, { rejectWithValue }) => {
        try {

            const response = await ProductRightSideRelatedEventsService.getProductRightSideRelatedEventsService(productPath)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const ProductRightSideRelatedEventsSlice = createSlice({
    name: 'ProductRightSideRelatedEvents',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveProductRightSideRelatedEvents.pending, (state) => {
                state.Loading = true;
            })
            .addCase(retrieveProductRightSideRelatedEvents.fulfilled, (state, action) => {
                if (action.payload) {
                    state.Loading = false;
                    state.rightSidePopularEventsData = action.payload as RightSideTrailType[];
                }
            })
            .addCase(retrieveProductRightSideRelatedEvents.rejected, (state, { payload }) => {
                state.Loading = false;
                state.Error = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default ProductRightSideRelatedEventsSlice.reducer;
